import { ImageLoaderCSSStyleImpl } from '../../../toolkit/imageloader/imageloadercss';


export class ToneDetailsPopupImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '189px', 
            height: '202px',
            borderRadius:'8px'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/tonedetailspopup/tonedetailsimageloadercss.ts